export const FUTURE_SPOT = "FUTURE_SPOT";
export const FUTURE_SPOT_ERROR = "FUTURE_SPOT_ERROR";
export const FUTURE_SPOT_HIDE_ERROR = "FUTURE_SPOT_HIDE_ERROR";
export const FUTURE_SPOT_START_LOADER = "FUTURE_SPOT_START_LOADER";
export const FUTURE_SPOT_STOP_LOADER = "FUTURE_SPOT_STOP_LOADER";
